import { render, staticRenderFns } from "./logincompon.vue?vue&type=template&id=95416004&scoped=true&"
import script from "./logincompon.vue?vue&type=script&lang=js&"
export * from "./logincompon.vue?vue&type=script&lang=js&"
import style0 from "./logincompon.vue?vue&type=style&index=0&id=95416004&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95416004",
  null
  
)

export default component.exports